<template>
  <div class="part-title">
    <dv-decoration-9 class="prefix">
      <dv-decoration-12 class="prefix-inner" />
    </dv-decoration-9>
    <div class="title">{{ title }}</div>
    <template v-if="hasSuffix">
      <dv-decoration-7 v-if="hasLink" style="width:130px;height:20px;">
        <span style="color: #ffffff;padding: 0 10px; cursor: pointer;" @click="onClick">{{ linkText }}</span>
      </dv-decoration-7>
      <dv-decoration-6 v-else class="suffix"  />
    </template>
    <dv-decoration-10 class="line" :dur="2" />
  </div>
</template>

<script>
export default {
  name: 'PartTitle',
  props: {
    title: { type: String, default: '' },
    hasLink: { type: Boolean, default: false },
    linkText: { type: String, default: '' },
    hasSuffix: { type: Boolean, default: true },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    onClick() {
      this.$emit('onLinkClick');
    },
  },
};
</script>

<style lang="scss" scoped>
.part-title {
  width: 94%;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  margin: 0 auto;

  .prefix {
    width: 28px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;

    .prefix-inner {
      width: 16px;
      height: 16px;
    }
  }
  .title {
    font-size: 16px;
    color: #ffffff;
    margin-left: 10px;
    flex: 1;
  }
  .line {
    width: 100%;
    height: 3px;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .suffix {
    width: 100px;
    height: 20px;
  }
}
</style>
